import React from "react";
import { DESCRIPTION_WARN_REMAINING } from "./quillDescriptionLimit";

export const FieldCharCount = ({
  length,
  max,
  warnAt = DESCRIPTION_WARN_REMAINING,
}) => {
  const remaining = Math.max(0, max - length);
  return (
    <div
      className={`create-promo-invite-modal__char-count${
        remaining <= warnAt ? " create-promo-invite-modal__char-count--limit" : ""
      }`}
    >
      {length}/{max}
    </div>
  );
};
